// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Position$XodProject = require("./Position.bs.js");

function create(patchPath) {
  return $dot$dot.createNode(Position$XodProject.origin, patchPath);
}

function setLabel(node, label) {
  return $dot$dot.setNodeLabel(label, node);
}

function setPosition(node, position) {
  return $dot$dot.setNodePosition(position, node);
}

function getId(prim) {
  return $dot$dot.getNodeId(prim);
}

function setId(prim, prim$1) {
  return $dot$dot.setNodeId(prim, prim$1);
}

function getType(prim) {
  return $dot$dot.getNodeType(prim);
}

function setType(prim, prim$1) {
  return $dot$dot.setNodeType(prim, prim$1);
}

function getLabel(prim) {
  return $dot$dot.getNodeLabel(prim);
}

function getPosition(prim) {
  return $dot$dot.getNodePosition(prim);
}

function isPinNode(prim) {
  return $dot$dot.isPinNode(prim);
}

exports.create = create;
exports.getId = getId;
exports.setId = setId;
exports.getType = getType;
exports.setType = setType;
exports.getLabel = getLabel;
exports.setLabel = setLabel;
exports.getPosition = getPosition;
exports.setPosition = setPosition;
exports.isPinNode = isPinNode;
/* .. Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-project/src/Node.bs.js
// module id = 639
// module chunks = 0